module.exports = __webpack_public_path__ + "img/gal_3.5c12ebb3.png";